<template>
    <div>

        <!-- Change Password Button -->
        <a class="btn custom-primary btn-primary float-left" @click="$bvModal.show('change-password-modal')">
            Change Password
        </a>

        <!-- Modal -->
        <b-modal
            id="change-password-modal"
            title="Reset Password"
            size="lg"
            hide-footer
            centered
            @hidden="resetForm"
        >

            <div id="passform">

                <div class="users-style">
                    <div class="form-wrapper pt-1">

                        <b-form @submit.stop.prevent="onSubmit">

                            <b-form-group
                                id="old_password-group"
                                label="Old Password"
                                label-for="old_password">

                                <b-form-input
                                    id="old_password"
                                    name="old_password"
                                    type="password"
                                    placeholder="Old Password"
                                    v-model="fdata.old_password"
                                    v-validate="{ required: true }"
                                    :state="validateState('old_password')"
                                    aria-describedby="old_password-feedback"
                                    data-vv-as="Old Password">
                                </b-form-input>

                                <b-form-invalid-feedback id="old_password-feedback">
                                    {{ veeErrors.first('old_password') }}
                                </b-form-invalid-feedback>

                            </b-form-group>

                            <b-form-group
                                id="password-group"
                                label="New Password"
                                label-for="password">

                                <b-form-input
                                    id="password"
                                    name="password"
                                    type="password"
                                    placeholder="New Password"
                                    v-model="fdata.password"
                                    v-validate="{ required: true, min: 8 }"
                                    :state="validateState('password')"
                                    aria-describedby="password-feedback"
                                    data-vv-as="New Password">
                                </b-form-input>

                                <b-form-invalid-feedback id="password-feedback">
                                    {{ veeErrors.first('password') }}
                                </b-form-invalid-feedback>

                            </b-form-group>

                            <b-form-group
                                id="password_confirmation-group"
                                label="Confirm Password"
                                label-for="password_confirmation">

                                <b-form-input
                                    id="password_confirmation"
                                    name="password_confirmation"
                                    type="password"
                                    placeholder="Confirm Password"
                                    autocomplete="off"
                                    v-model="fdata.password_confirmation"
                                    v-validate="{ required: true, confirmed: fdata.password }"
                                    :state="validateState('password_confirmation')"
                                    aria-describedby="password_confirmation-feedback"
                                    data-vv-as="Confirm Password">
                                </b-form-input>

                                <b-form-invalid-feedback id="password_confirmation-feedback">
                                    {{ veeErrors.first('password_confirmation') }}
                                </b-form-invalid-feedback>

                            </b-form-group>

                            <div class="text-right">
                                <b-button
                                    variant="secondary"
                                    @click="$bvModal.hide('change-password-modal')">
                                    Cancel
                                </b-button>

                                <b-button
                                    class="ml-2"
                                    variant="primary"
                                    type="submit">
                                    Update Password
                                </b-button>
                            </div>

                        </b-form>

                    </div>
                </div>

            </div>

        </b-modal>

    </div>
</template>
<script>

export default {
   

    data() {
        return {
            successmsg: '',
            errormsg: [],
            fdata: {
                old_password: '',
                password: '',
                password_confirmation: ''
            },

            showoverlay: false,
            
            sitekey: '6Leg2jMqAAAAAD_UnKTKkLpPof4VETXi8nBo7nU0',
        };
    },

    mounted() {

    },

    created() {

    },

    watch: {

    },

    methods: {

        // Open Modal
        openPasswordModal() {
            this.resetForm();
            this.$bvModal.show('change-password-modal');
        },

        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

        resetvalidator() {
            this.$validator.reset();
        },

        validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },

        resetForm() {
            this.fdata = {
                old_password: '',
                password: '',
                password_confirmation: ''
            };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },

        

        onSubmit(e) {

            if (!this.checkNet()) return false;

            let submitUrl = this.$api_url + '/employee/password/reset';

            this.$validator.validateAll().then(result => {

                if (!result) {
                    return;
                }

                e.preventDefault();

                let currentObj = this;

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    formData.append(key, value);
                }

                axios.post(submitUrl, formData)
                    .then(function (response) {

                        this.showoverlay = false;

                        if (response.data.flg == 1) {

                            currentObj.$bvToast.toast('Password Reset Done.', {
                                title: 'Info',
                                variant: 'success',
                                solid: true,
                                toaster: 'b-toaster-top-center',
                            });

                            // Close Modal
                            currentObj.$bvModal.hide('change-password-modal');

                            // Clear Form
                            currentObj.resetForm();

                            // Redirect after 1.5 sec
                            setTimeout(() => {
                                window.location.href = this.$api_url;
                            }, 1500);

                        } else {

                            currentObj.$bvToast.toast('Wrong Old Password.', {
                                title: 'Info',
                                variant: 'danger',
                                solid: true,
                                toaster: 'b-toaster-top-center',
                            });

                        }

                    }.bind(this))
                    .catch(function (error) {

                        this.showoverlay = false;
                        currentObj.serverError(error);

                    }.bind(this));

            });

        }

    }
};
</script>